import React, { useEffect, useState } from "react";
import * as notify from "shared/notify";
import classnames from "classnames";
import eventEmitter from "shared/events";

import { KEYCODE } from "shared/constants";
import { Select, Input } from "components/form-inputs/inputs";
import { useInput } from "shared/hooks/form-fields";
import MultiSelect from "components/form-inputs/custom/multi-select";
import { getTaskOptions, sendNote } from "components/notes/lib/data";

const taskOptions = getTaskOptions();
const SOURCE_PAGE = "shipment";

const AddNote = ({ addNotes, bins, shipmentKey }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const noteInput = useInput("");
    const selectNoteType = useInput(shipmentKey);
    const selectTask = useInput("");
    const binOptions = bins.map((b) => {
        return {
            text: `Bin: ${b}`,
            value: b,
        };
    });
    const [noteTypeOptions, setNoteTypeIptions] = useState([
        {
            text: "Entire Shipment",
            value: shipmentKey,
        },
        ...binOptions,
    ]);

    useEffect(() => {
        const otherOptions = bins.map((b) => {
            return {
                text: `Bin: ${b}`,
                value: b,
            };
        });
        setNoteTypeIptions([
            {
                text: "Entire Shipment",
                value: shipmentKey,
            },
            ...otherOptions,
        ]);
    }, [bins]);

    const saveOnEnter = (e) => {
        if (e.which === KEYCODE.RETURN || e.keyCode === KEYCODE.RETURN) {
            if (!e.shiftKey) {
                e.preventDefault();
                e.stopPropagation();
                onAdd();
            }
        }
    };

    const onAdd = async () => {
        if (isSubmitting) {
            return;
        }

        let hasError = false;

        if (!noteInput.value) {
            notify.error("Please enter a note");
            hasError = true;
        }

        if (!selectTask.value || selectTask.value.length < 1) {
            notify.error("Please select a task");
            hasError = true;
        }

        if (hasError) {
            return;
        }

        setIsSubmitting(true);

        const additionalOptions =
            selectNoteType.value === shipmentKey ? { shipmentKey: selectNoteType.value, noteType: "Shipment" } : { shipmentKey: shipmentKey, binTrackingNumber: selectNoteType.value, noteType: "Bin" };

        const tasksRequested = selectTask.value.map((selection) => {
            return selection.value;
        });

        const notes = tasksRequested.includes("all")
            ? [
                  {
                      ...additionalOptions,
                      noteText: noteInput.value,
                      taskType: "",
                  },
              ]
            : tasksRequested.map((task) => {
                  return {
                      ...additionalOptions,
                      noteText: noteInput.value,
                      taskType: task,
                  };
              });

        const payload = {
            items: notes,
        };
        const response = await sendNote(payload, SOURCE_PAGE);

        if (!response) {
            setIsSubmitting(false);

            return;
        }

        if (response.length === notes.length) {
            notify.success("Notes Saved");
            addNotes(response);
            noteInput.reset();
            selectTask.reset();
            eventEmitter.emit("NOTE_ADDED");
        }

        setIsSubmitting(false);
    };

    return (
        <div className="input-group -no-margin -align-bottom">
            <Select label="Add note to" options={noteTypeOptions} {...selectNoteType.bind} excludeSelect={true} />
            <Input {...noteInput.bind} label="Note" onKeyPress={saveOnEnter} />
            <MultiSelect label="Task(s)" options={taskOptions} {...selectTask.bind} showBelow={true} />
            <button className={classnames("button -primary -margin-left", { "-disabled": isSubmitting })} onClick={onAdd}>
                Add Note
            </button>
        </div>
    );
};

export default AddNote;
